<template>
  <div class="qr_popup" v-if="tktQrOrder">
    <div class="bg" @click="resetTktQr"></div>
    <div class="pop_up">
      <div class="head">
          <p>{{ $t("tickets_and_bar.operations.tickets") }}</p>
          <div class="close" @click="resetTktQr"></div>
      </div>
      <div class="body">
        <div class="tickets-center">
          <div class="tickets-top" v-if="winW > 1024">
            {{ $t("pop_ups.qr_code.ticket") }} <span>#{{ tktQrIndex + 1 }}</span>
          </div>
          <div class="mobile-qrs" v-if="winW <= 1024" :class="{'center-it': tktQrOrder.tickets.length == 1}">
            <div class="mobile-qr" v-for="(ticket, ticketNum) in tktQrOrder.tickets" :key="ticketNum">
              <div class="tickets-top">
                {{ $t("pop_ups.qr_code.ticket") }} <span>#{{ ticketNum + 1 }}</span>
              </div>
              <qrcode :value="mobileTickets(ticketNum)" :options="{size: 208}"></qrcode>
              <div class="tickets-bottom">
                <p class="ticket_info">
                  <span>{{ $t("pop_ups.qr_code.row") }}: {{ tktQrOrder.tickets[ticketNum].row }}</span>
                  <span>{{ $t("pop_ups.qr_code.place") }}: {{ tktQrOrder.tickets[ticketNum].seat }}</span>
                </p>
                <p class="bar_hint">{{ mobileTickets(ticketNum) }}</p>
              </div>
            </div>
          </div>
          <qrcode v-if="winW > 1024" :value="qrValue" :options="{size: 208}"></qrcode>
          <div class="tickets-bottom" v-if="winW > 1024">
            <p class="ticket_info">
               <span>{{ $t("pop_ups.qr_code.row") }}: {{ tktQrOrder.tickets[tktQrIndex].row }}</span>
               <span>{{ $t("pop_ups.qr_code.place") }}: {{ tktQrOrder.tickets[tktQrIndex].seat }}</span>
            </p>
            <p class="bar_hint">{{ qrValue }}</p>
          </div>
        </div>
        <div class="dec" v-if="tktQrOrder.tickets.length > 1 && tktQrIndex > 0 && winW > 1024" @click="decrementTktQr">
          <svg xmlns="http://www.w3.org/2000/svg" width="37" height="65"><g fill="none" fill-rule="evenodd"><path d="M35.586 0h-34v65h34z"/><path fill="#FFF" fill-rule="nonzero" d="M1.586 1.405L2.995 0l32.59 32.5L2.996 65l-1.41-1.405L32.768 32.5z"/></g></svg>
        </div>
        <div class="inc" v-if="tktQrOrder.tickets.length > 1 && tktQrIndex < tktQrOrder.tickets.length - 1 && winW > 1024" @click="incrementTktQr">
          <svg xmlns="http://www.w3.org/2000/svg" width="37" height="65"><g fill="none" fill-rule="evenodd"><path d="M35.586 0h-34v65h34z"/><path fill="#FFF" fill-rule="nonzero" d="M1.586 1.405L2.995 0l32.59 32.5L2.996 65l-1.41-1.405L32.768 32.5z"/></g></svg>
        </div>
        <p class="bar_hint">{{ $t("commons.bar_hint") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import Store from '../../store'
  export default {
    computed: {
      tktQrOrder: function () {
        return Store.state.tktQrOrder
      },
      tktQrIndex: function () {
        return Store.state.tktQrIndex
      },
      tktQrMovie: function () {
        return Store.state.tktQrMovie
      },
      winW: function () {
        return Store.state.winW
      },
      qrValue: function () {
        var ticketType
        var currentTicket = this.tktQrOrder.tickets[this.tktQrIndex]
        if (currentTicket.item.indexOf('TT') !== -1) {
          ticketType = 'T'
        } else {
          ticketType = 'B'
        }
        if (this.tktQrOrder.cinema === 1001) {
          return ticketType + '1000' + this.padWithZeros(this.tktQrOrder.transaction_number.toString(), 7) + this.padWithZeros(currentTicket.sequence.toString(), 4)
        }
        return ticketType + this.tktQrOrder.cinema + ' ' + this.padWithZeros(this.tktQrOrder.transaction_number.toString(), 7) + this.padWithZeros(currentTicket.sequence.toString(), 4)
      }
    },
    methods: {
      incrementTktQr: function () {
        Store.commit('incrementTktQr')
      },
      mobileTickets: function (i) {
        var ticketType
        var currentTicket = this.tktQrOrder.tickets[i]
        if (currentTicket.item.indexOf('TT') !== -1) {
          ticketType = 'T'
        } else {
          ticketType = 'B'
        }
        if (this.tktQrOrder.cinema === 1001) {
          return ticketType + '1000' + this.padWithZeros(this.tktQrOrder.transaction_number.toString(), 7) + this.padWithZeros(currentTicket.sequence.toString(), 4)
        }
        return ticketType + this.tktQrOrder.cinema + ' ' + this.padWithZeros(this.tktQrOrder.transaction_number.toString(), 7) + this.padWithZeros(currentTicket.sequence.toString(), 4)
      },
      decrementTktQr: function () {
        Store.commit('decrementTktQr')
      },
      resetTktQr: function () {
        Store.commit('resetTktQr')
      },
      padWithZeros: function (str, targetLength) {
        while (str.length < targetLength) {
          str = '0' + str
        }
        return str
      }
    }
  }
</script>



// WEBPACK FOOTER //
// qr-code.vue?7b6fc533